module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Medium.ttf?5d434cfa8dd4128e86a6e0f424112c30";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Medium.ttf
// module id = 1408
// module chunks = 0